
export type MemberType = typeof MemberType[keyof typeof MemberType];


export const MemberType = {
  Member: 'Member',
  Owner: 'Owner',
} as const;
